import { InteractionRequiredAuthError, ServerError } from '@azure/msal-browser';

/**
 * Custom error class for admin consent required scenarios (AADSTS65001)
 */
export class AdminConsentRequiredError extends Error {
  constructor() {
    super('Admin consent required');
    this.name = 'AdminConsentRequiredError';
    Object.setPrototypeOf(this, AdminConsentRequiredError.prototype);
  }
}

/**
 * Checks if the error is an admin consent required error (AADSTS65001)
 * This error occurs when the Azure AD app requires permissions that haven't been admin-consented
 * Handles both MSAL errors and Office SSO errors
 */
export const isAdminConsentRequiredError = (error: unknown): boolean => {
  // Check MSAL errors
  if (error instanceof InteractionRequiredAuthError || error instanceof ServerError) {
    return error.errorMessage?.includes('AADSTS65001') ?? false;
  }

  // Check generic errors (e.g., Office SSO errors)
  if (error instanceof Error) {
    return error.message?.includes('AADSTS65001') ?? false;
  }

  return false;
};
